/*** 反作弊 ***/
import { http } from '@/api/http';

export default {
    uploadInvigilate(data) {
        return http.post(`/api/AntiCheating/UploadInvigilate`, data, {contentType: 'file', noShowError: true});
    },

    getProcessingExam(data) {
        return http.get('/api/AntiCheating/GetExaminationProcessing', data)
    },

    getInvigilatePhotoList(data) {
        return http.get('/api/AntiCheating/GetInvigilatePhotoList', data)
    },

    getInvigilatePhotoDetails(data) {
        return http.get('/api/AntiCheating/GetInvigilatePhotoDetails', data)
    }
}
